var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',_vm._b({attrs:{"color":_vm.color,"right":"","rounded":"lg","text":"","top":""},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},'v-snackbar',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }